import { render } from "./TheFaqHome.vue?vue&type=template&id=b442edf4&scoped=true&ts=true&lang=html"
import script from "./TheFaqHome.vue?vue&type=script&lang=ts"
export * from "./TheFaqHome.vue?vue&type=script&lang=ts"

import "./TheFaqHome.vue?vue&type=style&index=0&id=b442edf4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b442edf4"]])

export default __exports__